import { ISchedule } from '~src/schedule/types/ISchedule';

import { Request } from '../../httpClient/serverApi/requests/Request';
import { IResult } from '../../httpClient/serverApi/types/IResponse';

export interface IGetUserIdentityMigrationBackgroundJobParams {
}

export interface IGetUserIdentityMigrationBackgroundJobResult extends IResult {
  schedule: ISchedule;
  isEnabled: boolean;
}

export class GetUserIdentityMigrationBackgroundJobRequest extends Request<IGetUserIdentityMigrationBackgroundJobParams, IGetUserIdentityMigrationBackgroundJobResult> {
  constructor(params: IGetUserIdentityMigrationBackgroundJobParams = {}) {
    super('getUserIdentityMigrationBackgroundJob', params);
  }
}
